import * as React from 'react'

import { Button, Radio, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type CustomPeriodForm from 'modules/attendance/components/TimeTracking/Layout/form'
import { PAYROLL_PERIOD_TYPES } from 'modules/attendance/components/TimeTracking/Layout/form'
import { useCompensationCycle } from 'modules/attendance/hooks/useCompensationCycle'
import {
  getCompensationPeriodDescription,
  getCompensationPeriods,
} from 'modules/attendance/lib/compensationPeriodUtils'
import type Period from 'modules/attendance/store/models/Period'

export interface Props {
  onSubmit: () => void
  onCloseModal: () => void
  selected: Period[]
  form: CustomPeriodForm
}

const CreateModal = ({ onSubmit, onCloseModal, selected, form }: Props) => {
  const [displayErrorMessage, setDisplayErrorMessage] = React.useState(false)

  const payrollTypeField = form.get('payroll_period_type')
  const payrollPeriodTypesArray = Object.values(PAYROLL_PERIOD_TYPES)

  const payrollPeriodAbsent = !payrollPeriodTypesArray.includes(payrollTypeField.value)

  const { cycleRecurrence } = useCompensationCycle()
  const compensationPeriods = getCompensationPeriods(cycleRecurrence)

  const submitOrDisplayError = () => {
    if (payrollPeriodAbsent) {
      setDisplayErrorMessage(true)
      return
    }

    onSubmit()
  }

  const onChangePayrollType = (value: string) => {
    payrollTypeField.set(value)
    setDisplayErrorMessage(false)
  }

  return (
    <Modal
      title={i18n.t('time_tracking.modals.compensation.payroll.create.title')}
      description={i18n.tp('time_tracking.modals.compensation.payroll.create.description', {
        count: selected.length,
      })}
      illustration="cash"
      onSubmit={submitOrDisplayError}
      onClose={onCloseModal}
      footer={
        <>
          <Button onClick={onCloseModal} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>
            {i18n.t('time_tracking.modals.compensation.payroll.create.submit')}
          </Button>
        </>
      }
    >
      <Radio.Wrap>
        <Radio
          name={compensationPeriods.current.label}
          value={payrollTypeField.value}
          onChange={(value) => onChangePayrollType(value)}
          description={getCompensationPeriodDescription(true)}
          option={{
            label: compensationPeriods.current.label,
            value: 'current',
          }}
        />
      </Radio.Wrap>
      <Radio.Wrap>
        <Radio
          name={compensationPeriods.next.label}
          value={payrollTypeField.value}
          onChange={(value) => onChangePayrollType(value)}
          description={getCompensationPeriodDescription(false)}
          option={{
            label: compensationPeriods.next.label,
            value: 'next',
          }}
        />
      </Radio.Wrap>

      {displayErrorMessage && (
        <Text.Normal color="radicalRed1000">
          {i18n.t('time_tracking.modals.compensation.payroll.create.error_message')}
        </Text.Normal>
      )}
    </Modal>
  )
}

export default observer(CreateModal)
